import axios from "axios";
import { canaveral_url, sisi2_api_url } from ".";

// ========================== REGISTER ===========================
export function registerSubagent({ payload }) {
  return axios.post(`${sisi2_api_url}/crm/subagents/`, payload);
}

export function uploadSubagentDocument(formData) {
  return axios.post(`${canaveral_url}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateSubagentDocument(uid, source_entity) {
  return axios.patch(`${canaveral_url}/documents/${uid}`, { source_entity });
}
